import { createFileRoute } from "@tanstack/react-router";
import { ensureRouteTranslationModuleLoaded } from "@/services/culture/routeTranslationPreload";

export const Route = createFileRoute("/dashboards/$id/")({
  beforeLoad: async () => {
    await ensureRouteTranslationModuleLoaded("dashboards");
  },
  staticData: {
    title: "apps.dashboards",
  },
});
